import SmallTitle from "../../components/shared/SmallTitle";
import Title from "../../components/shared/Title";
import Description from "../../components/shared/Description";
import "./Roadmap.scss";
import RoadmapDesktop from "./components/RoadmapDesktop";
import { useState } from "react";
import RoadmapMobile from "./components/RoadmapMobile";

import DesktopOval1 from "../../assets/images/decoration/desktop-oval-1.svg";
import SpotLight1 from "../../assets/images/decoration/spot-light-1.svg";
import RoadmapSharpLightsDesktop from "../../assets/images/decoration/roadmap-sharp-lights-desktop.svg";

export default function Roadmap() {
	const [activeQuarter, setActiveQuarter] = useState("q1");

	return (
		<>
			<div className="roadmap" id="roadmap">
				<img
					className="decoration sharp-lights"
					src={RoadmapSharpLightsDesktop}
					alt="decorative-img"
				/>
				
				<div className="roadmap-content-wrapper content-wrapper-lg">
					<img
						className="decoration desktop-light-1"
						src={DesktopOval1}
						alt="decorative-img"
					/>

					<img
						className="decoration spot-light-1"
						src={SpotLight1}
						alt="decorative-img"
					/>

					<div className="roadmap-content">
						<SmallTitle className="roadmap-small-title" data-aos="fade-up">
							Our Roadmap
						</SmallTitle>

						<Title className="roadmap-title" data-aos="fade-up" data-aos-delay="100">
							Building a Decentralized Tomorrow, One Milestone at
							a Time
						</Title>

						<Description className="roadmap-desc" data-aos="fade-up" data-aos-delay="200">
							Our roadmap highlights key milestones .
						</Description>
					</div>

					<div className="roadmap-chart">
						<div className="roadmap-desktop" data-aos="zoom-in">
							<RoadmapDesktop
								activeQuarter={activeQuarter}
								onQuarterChange={setActiveQuarter}
							/>
						</div>

						<div className="roadmap-mobile" data-aos="zoom-in">
							<RoadmapMobile
								activeQuarter={activeQuarter}
								onQuarterChange={setActiveQuarter}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
